import { isEmptyOrWhiteSpace } from 'utils/string';
import { environment } from 'environments/environment';

/*
Functions to handle URL string manipulations, particularly for sanitising parameters
for Cross-Site Scripting (XSS) attacks purposes.
*/

function DomainFromURL(url: string): string | null {
	const prefix = /^https?:\/\//i;
	const domain = /^[^\/:]+/;
	//Remove any prefix.
	url = url.replace(prefix, '');
	//Assume any URL that starts with a / is on the current page's domain.
	if (url.charAt(0) === '/') {
		url = window.location.hostname + url;
	}
	//Now extract just the domain.
	const match = url.match(domain);
	if (match) {
		return match[0];
	}
	return null;
}

function SameDomains(url1: string, url2: string): boolean {
	if (isEmptyOrWhiteSpace(url1) && isEmptyOrWhiteSpace(url2)) {
		return false;
	}

	const domain1 = DomainFromURL(url1);
	const domain2 = DomainFromURL(url2);
	return domain1 === domain2;
}

export function RedirectURL(redirectParam: string): string | null {
	const siteURL = environment.superhogApp;
	if (!redirectParam || redirectParam.startsWith('unsafe:') || !SameDomains(redirectParam, siteURL)) {
		return null;
	}
	return redirectParam;
}
